module.exports = __webpack_public_path__ + "img/homeTipBg1.d152cd1a.png";